module.exports = __webpack_public_path__ + "img/transfer-layer.f5e80f6c.png";